export default {
  id: 235,
  title: 'Target #235 - Website',
  url: 'https://cssbattle.dev/play/235',
  colors: ['#FDFFE9', '#ADB274', '#555A2A'],
  solution:
    '<p a><p b><p c><p d><p e><style>p[b],p[c]{left:110;width:270}p[a],p[d]{left:20;background:#adb274}p[a],p[b],p[c],p[d]{background:#adb274}body{background:#fdffe9}p{position:fixed;margin:0}p[a]{top:20;width:360;height:30;box-shadow:0 230px #adb274}p[b]{top:110;height:60;box-shadow:0 70px #adb274}p[c]{top:60;height:40}p[d]{top:60;width:80;height:180}p[e]{top:25;left:25;width:20;height:20;background:#555a2a;box-shadow:330px 0 #555a2a,135px 230px #555a2a,165px 230px #555a2a,195px 230px #555a2a',
}
